import { render } from "./NewsletterSectionsMarketHighlightsEditing.vue?vue&type=template&id=4718f544&ts=true"
import script from "./NewsletterSectionsMarketHighlightsEditing.vue?vue&type=script&lang=ts"
export * from "./NewsletterSectionsMarketHighlightsEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__